<template>
    <svg
        id="_x32_"
        height="800px"
        width="800px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve"
    >
        <g>
            <path
                class="st0"
                d="M255.992,0C184.108,0,116.46,64.412,141.82,188.497c5.047,24.648,18.6,52.267,37.076,80.704
            c23.1-20.859,45.639-42.536,65.43-63.834c-6.338-7.181-12.344-14.297-17.921-21.305c-45.946-57.778-38.06-128.52,29.588-128.52
            c67.664,0,75.549,70.742,29.604,128.52C201.036,290.416,18.769,420.408,18.769,420.408l83.534,19.642l1.465,71.95
            c0,0,241.028-199.419,266.404-323.503C395.541,64.412,327.876,0,255.992,0z"
            />
            <path
                class="st0"
                d="M336.192,295.28c-18.17,25.898-41.014,53.889-68.409,83.914C336.911,452.99,408.232,512,408.232,512
            l7.563-71.95l77.436-19.642C493.231,420.408,414.281,364.104,336.192,295.28z"
            />
        </g>
    </svg>
</template>
<style type="text/css" scoped>
.st0 {
    fill: #ff85c5;
}
</style>
